import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { Badge } from './ui/badge';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const NotificationBell = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [unreadCount, setUnreadCount] = useState(0);

  useEffect(() => {
    if (user) {
      fetchUnreadCount();
      
      // Atualizar a cada 30 segundos
      const interval = setInterval(fetchUnreadCount, 30000);
      return () => clearInterval(interval);
    }
  }, [user]);

  const fetchUnreadCount = async () => {
    try {
      const response = await axios.get(`${API}/support/unread-count`, {
        withCredentials: true,
        validateStatus: s => s === 200 || s === 401
      });
      
      if (response.status === 200) {
        setUnreadCount(response.data.count || 0);
      }
    } catch (error) {
      // Ignorar erro
    }
  };

  const handleClick = () => {
    // Zerar contador ao clicar
    setUnreadCount(0);
    
    if (user?.role === 'admin') {
      navigate('/admin/messages');
    } else {
      navigate('/contact');
    }
  };

  if (!user) return null;

  return (
    <Button
      onClick={handleClick}
      variant="ghost"
      size="icon"
      className="relative hover:bg-orange-50"
    >
      <Bell className="w-5 h-5 text-gray-700" />
      {unreadCount > 0 && (
        <Badge className="absolute -top-1 -right-1 bg-red-600 text-white text-xs px-1.5 min-w-[20px] h-5">
          {unreadCount > 9 ? '9+' : unreadCount}
        </Badge>
      )}
    </Button>
  );
};

export default NotificationBell;
